import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import Disposisi from '../../../utilities/Disposisi';

const ModalLapOrg = ({ showAddLapOrg, handleCloseAddLapOrg, dataDisposisi, datappm }) => {

    return (
        <>
            <Modal
                show={showAddLapOrg}
                onHide={handleCloseAddLapOrg}
                backdrop='static'
                keyboard={false}
                scrollable={true}
                size='xl'
                centered
            >
                <Modal.Header><h6><Disposisi idDisposisi={dataDisposisi.idDisposisi} /></h6></Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor Aju</label>
                        <div className="col-sm-6">
                            <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={datappm.nomorAju} readOnly />
                        </div>
                    </div>
                    <Button variant="primary" size="sm">Simpan</Button>{' '}
                    <Button variant="secondary" size="sm" onClick={handleCloseAddLapOrg}>
                        Close
                    </Button>
                </Modal.Body>
            </Modal>

        </>
    )
}

export default ModalLapOrg